import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, withCtx as _withCtx, renderList as _renderList, createBlock as _createBlock, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "pb-detail"
}
const _hoisted_3 = { class: "page-bar-sub" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "pb-title" }
const _hoisted_6 = { class: "page-bar-main" }
const _hoisted_7 = {
  key: 0,
  class: "dbadge st-draft"
}
const _hoisted_8 = {
  key: 1,
  class: "dbadge st-review"
}
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "page-bar-owner" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "page-bar-sub" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { class: "page-bar-main" }
const _hoisted_17 = {
  key: 2,
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_18 = {
  key: 3,
  class: "pb-actions"
}
const _hoisted_19 = {
  viewBox: "0 0 24 24",
  style: {"fill":"currentColor","stroke":"none"},
  "aria-hidden": "true"
}
const _hoisted_20 = { class: "pb-more" }
const _hoisted_21 = ["aria-expanded"]
const _hoisted_22 = {
  key: 0,
  type: "button",
  class: "pb-mi disable-button",
  role: "menuitem",
  disabled: ""
}
const _hoisted_23 = {
  key: 0,
  class: "pb-sep"
}
const _hoisted_24 = ["title"]
const _hoisted_25 = {
  style: {"display":"flex","align-items":"center"},
  class: "hide-mobile-991"
}
const _hoisted_26 = {
  key: 1,
  class: "pb-blocked slide-up",
  role: "alert"
}
const _hoisted_27 = {
  key: 0,
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_28 = {
  key: 1,
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_29 = { class: "pb-blocked-btns" }
const _hoisted_30 = {
  key: 0,
  class: "pb-pdf-status"
}
const _hoisted_31 = { key: 0 }
const _hoisted_32 = {
  key: 1,
  class: "page-filters pf-bar"
}
const _hoisted_33 = { key: 2 }
const _hoisted_34 = {
  key: 0,
  class: "next-nodes-grid"
}
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "next-node-card-top" }
const _hoisted_37 = { class: "next-node-card-name" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = {
  key: 0,
  class: "next-node-card-sub"
}
const _hoisted_40 = ["onClick"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "next-node-menu-info" }
const _hoisted_43 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_44 = {
  key: 1,
  class: "next-nodes-preview"
}
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { class: "btn" }
const _hoisted_49 = { style: {"margin-top":"25px"} }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = {
  key: 2,
  style: {"margin-top":"24px"}
}
const _hoisted_53 = {
  key: 3,
  class: "playbook-processes"
}
const _hoisted_54 = ["innerHTML"]
const _hoisted_55 = { key: 0 }
const _hoisted_56 = ["src"]
const _hoisted_57 = { key: 1 }
const _hoisted_58 = ["src"]
const _hoisted_59 = {
  key: 2,
  class: "video-wrap",
  style: {"width":"100%"}
}
const _hoisted_60 = { class: "video" }
const _hoisted_61 = {
  key: 0,
  allowfullscreen: "1",
  autostart: "0",
  controls: ""
}
const _hoisted_62 = ["src"]
const _hoisted_63 = ["src"]
const _hoisted_64 = { key: 4 }
const _hoisted_65 = { key: 5 }
const _hoisted_66 = { key: 6 }
const _hoisted_67 = { class: "video-wrap" }
const _hoisted_68 = { class: "video" }
const _hoisted_69 = {
  key: 0,
  allowfullscreen: "1",
  autostart: "0",
  controls: ""
}
const _hoisted_70 = ["src"]
const _hoisted_71 = ["src"]
const _hoisted_72 = {
  key: 7,
  class: "playbook-processes"
}
const _hoisted_73 = { style: {"margin":"0 0 25px 0"} }
const _hoisted_74 = { key: 8 }
const _hoisted_75 = {
  key: 3,
  class: "error-msg-wrap"
}
const _hoisted_76 = { class: "form-wrapper slide-up" }
const _hoisted_77 = { class: "form-close" }
const _hoisted_78 = { style: {"height":"100px","border-bottom":"1px solid black","margin":"0 10px 10px"} }
const _hoisted_79 = { style: {"padding":"0 10px 10px"} }
const _hoisted_80 = ["aria-label"]
const _hoisted_81 = { class: "ve-present-bar" }
const _hoisted_82 = { class: "ve-present-title" }
const _hoisted_83 = { class: "ve-present-body" }
const _hoisted_84 = {
  key: 5,
  class: "error-msg-wrap"
}
const _hoisted_85 = {
  class: "form-wrapper slide-up",
  style: {"width":"auto"}
}
const _hoisted_86 = { class: "form-close" }
const _hoisted_87 = { style: {"text-align":"center"} }
const _hoisted_88 = ["src"]
const _hoisted_89 = {
  key: 6,
  class: "error-msg-wrap"
}
const _hoisted_90 = { class: "form-wrapper slide-up" }
const _hoisted_91 = { class: "form-close" }
const _hoisted_92 = { style: {"margin-bottom":"15px","text-decoration":"underline"} }
const _hoisted_93 = {
  key: 0,
  class: "checkbox-input"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ai_forge_name = _resolveComponent("ai-forge-name")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_forge_daily_digest = _resolveComponent("forge-daily-digest")!
  const _component_employee_home_node = _resolveComponent("employee-home-node")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_announcements_home_node = _resolveComponent("announcements-home-node")!
  const _component_process_header = _resolveComponent("process-header")!
  const _component_value_engine_view = _resolveComponent("value-engine-view")!
  const _component_role_sheet_view = _resolveComponent("role-sheet-view")!
  const _component_checklist = _resolveComponent("checklist")!
  const _component_nodes_home_node = _resolveComponent("nodes-home-node")!
  const _component_node_admin_component = _resolveComponent("node-admin-component")!
  const _component_VueSignaturePad = _resolveComponent("VueSignaturePad")!
  const _component_phone_input = _resolveComponent("phone-input")!
  const _component_who_can_view = _resolveComponent("who-can-view")!
  const _component_pdf_pop_up = _resolveComponent("pdf-pop-up")!
  const _component_ai_create_node = _resolveComponent("ai-create-node")!
  const _component_add_edit_node = _resolveComponent("add-edit-node")!
  const _component_add_existing_node = _resolveComponent("add-existing-node")!
  const _component_confirm_delete = _resolveComponent("confirm-delete")!
  const _component_process_suggestion_form = _resolveComponent("process-suggestion-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.hideBar && !_ctx.blocked)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["page-bar", { 'playbook-has-ai': !_ctx.previewNode && _ctx.canEditNodes && _ctx.node.Type == 'NODE' && _ctx.node.Slug != 'home' }])
        }, [
          (_ctx.isContentNode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  (_ctx.previewNode)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Preview · not saved"))
                    : (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        class: "pb-crumb",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.goBack()), ["prevent"]))
                      }, [
                        _cache[54] || (_cache[54] = _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                          _createElementVNode("path", { d: "M19 12H5M11 18l-6-6 6-6" })
                        ], -1)),
                        _createTextVNode(_toDisplayString(_ctx.typeCrumb), 1)
                      ]))
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, [
                    _createVNode(_component_ai_forge_name, {
                      name: _ctx.node.Name
                    }, null, 8, ["name"])
                  ]),
                  (!_ctx.previewNode)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.node.NeedsApproval)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.node.NeedsApprovalType || 'Draft'), 1))
                          : (_ctx.node.NeedsReview && _ctx.canMarkReviewed)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Needs review"))
                            : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(_ctx.isFavorite ? 'page-bar-fav on' : 'page-bar-fav'),
                          title: _ctx.isFavorite ? 'Remove from favorites' : 'Add to favorites',
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleFavorite()))
                        }, [
                          _createVNode(_component_svg_icon, {
                            icon: _ctx.isFavorite ? 'starfilled' : 'star'
                          }, null, 8, ["icon"])
                        ], 10, _hoisted_9)
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.metaLine), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  (_ctx.previewNode)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Preview · not saved"))
                    : (_ctx.node.Slug == 'home' && _ctx.$store.state.user.firstName)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Welcome back, " + _toDisplayString(_ctx.$store.state.user.firstName), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_15, "Foundations"))
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.node.Name), 1)
                ])
              ])),
          (_ctx.previewNode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-light",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close-preview')))
                }, "Close Preview")
              ]))
            : (_ctx.isContentNode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  (_ctx.node.Type == 'TIMELINE' && _ctx.timeline)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn-light pb-btn",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.presenting = true))
                      }, [...(_cache[55] || (_cache[55] = [
                        _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                          _createElementVNode("path", { d: "M3 4h18M4 4v11a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V4M12 16v4M8 20h8" })
                        ], -1),
                        _createElementVNode("span", null, "Present", -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  (_ctx.canImprove)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "ai-btn pb-btn",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.improveWithAI()))
                      }, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_19, [...(_cache[56] || (_cache[56] = [
                          _createElementVNode("path", { d: "M13 0L3.5 14H10l-1.5 10L20 9h-6.5L15 0h-2z" }, null, -1)
                        ]))])),
                        _cache[57] || (_cache[57] = _createElementVNode("span", null, "Improve with AI", -1))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.$store.state.user.isAdmin)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        type: "button",
                        class: "btn-light pb-btn",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showWhoCanView = true))
                      }, [...(_cache[58] || (_cache[58] = [
                        _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                          _createElementVNode("path", { d: "M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" }),
                          _createElementVNode("circle", {
                            cx: "12",
                            cy: "12",
                            r: "3"
                          })
                        ], -1),
                        _createElementVNode("span", null, "Who Can View", -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "pb-kebab",
                      "aria-haspopup": "menu",
                      "aria-expanded": _ctx.showDetailMenu,
                      "aria-label": "More actions",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showDetailMenu = !_ctx.showDetailMenu))
                    }, [
                      _createVNode(_component_svg_icon, { icon: "dots" })
                    ], 8, _hoisted_21),
                    (_ctx.showDetailMenu)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "pb-menu",
                          role: "menu",
                          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showDetailMenu = false))
                        }, [
                          (_ctx.canMarkReviewed || (_ctx.canEditNodes && _ctx.node.Slug != 'home'))
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (_ctx.canMarkReviewed)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (_ctx.reviewedToday)
                                        ? (_openBlock(), _createElementBlock("button", _hoisted_22, [...(_cache[59] || (_cache[59] = [
                                            _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                              _createElementVNode("path", { d: "M5 12.5l4.5 4.5L19 7.5" })
                                            ], -1),
                                            _createTextVNode("Reviewed today ", -1)
                                          ]))]))
                                        : (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            type: "button",
                                            class: "pb-mi",
                                            role: "menuitem",
                                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.markReviewed()))
                                          }, [...(_cache[60] || (_cache[60] = [
                                            _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                              _createElementVNode("path", { d: "M5 12.5l4.5 4.5L19 7.5" })
                                            ], -1),
                                            _createTextVNode("Mark reviewed ", -1)
                                          ]))]))
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (_ctx.canEditNodes && _ctx.editRoute)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      type: "button",
                                      class: "pb-mi",
                                      role: "menuitem",
                                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$router.push(_ctx.editRoute)))
                                    }, [...(_cache[61] || (_cache[61] = [
                                      _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                        _createElementVNode("path", { d: "M4 20h4L18.5 9.5a2.83 2.83 0 0 0-4-4L4 16v4M13.5 6.5l4 4" })
                                      ], -1),
                                      _createTextVNode("Edit ", -1)
                                    ]))]))
                                  : _createCommentVNode("", true),
                                (_ctx.canEditNodes && _ctx.node.Slug != 'home')
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 2,
                                      type: "button",
                                      class: "pb-mi",
                                      role: "menuitem",
                                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.editDetails()))
                                    }, [...(_cache[62] || (_cache[62] = [
                                      _createStaticVNode("<svg viewBox=\"0 0 24 24\"><path d=\"M4 6h10M18 6h2M4 12h4M12 12h8M4 18h12\"></path><circle cx=\"16\" cy=\"6\" r=\"2\"></circle><circle cx=\"10\" cy=\"12\" r=\"2\"></circle><circle cx=\"18\" cy=\"18\" r=\"2\"></circle></svg>Edit Details ", 2)
                                    ]))]))
                                  : _createCommentVNode("", true),
                                _cache[63] || (_cache[63] = _createElementVNode("div", { class: "pb-sep" }, null, -1))
                              ], 64))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            type: "button",
                            class: "pb-mi",
                            role: "menuitem",
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.sharePDF()))
                          }, [...(_cache[64] || (_cache[64] = [
                            _createStaticVNode("<svg viewBox=\"0 0 24 24\"><circle cx=\"6\" cy=\"12\" r=\"3\"></circle><circle cx=\"18\" cy=\"6\" r=\"3\"></circle><circle cx=\"18\" cy=\"18\" r=\"3\"></circle><path d=\"M8.7 10.7l6.6-3.4M8.7 13.3l6.6 3.4\"></path></svg>Share ", 2)
                          ]))]),
                          (_ctx.node.Type != 'VIDEO')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: _normalizeClass(_ctx.gettingPDF ? 'pb-mi disable-button' : 'pb-mi'),
                                  role: "menuitem",
                                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.getPDF(false)))
                                }, [...(_cache[65] || (_cache[65] = [
                                  _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                    _createElementVNode("path", { d: "M14 3v4a1 1 0 0 0 1 1h4M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2zM12 11v6M9 14l3 3 3-3" })
                                  ], -1),
                                  _createTextVNode("Download PDF ", -1)
                                ]))], 2),
                                (_ctx.node.Type == 'CHECKLIST')
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      type: "button",
                                      class: _normalizeClass(_ctx.gettingPDF ? 'pb-mi disable-button' : 'pb-mi'),
                                      role: "menuitem",
                                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.getPDF(true)))
                                    }, [...(_cache[66] || (_cache[66] = [
                                      _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                        _createElementVNode("path", { d: "M14 3v4a1 1 0 0 0 1 1h4M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2zM9 13h6M9 17h6" })
                                      ], -1),
                                      _createTextVNode("PDF w/ Lines ", -1)
                                    ]))], 2))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.$store.state.user.isAdmin)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 2,
                                type: "button",
                                class: _normalizeClass(_ctx.gettingPDF ? 'pb-mi disable-button' : 'pb-mi'),
                                role: "menuitem",
                                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.getQRPDF()))
                              }, [...(_cache[67] || (_cache[67] = [
                                _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                  _createElementVNode("path", { d: "M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h2v2h-2zM18 14h2M14 18v2M18 18h2v2h-2" })
                                ], -1),
                                _createTextVNode("QR code ", -1)
                              ]))], 2))
                            : _createCommentVNode("", true),
                          (_ctx.$store.state.user.isAdmin && _ctx.node.Type != 'VIDEO')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                (_ctx.canEditNodes)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_23))
                                  : _createCommentVNode("", true),
                                (_ctx.canEditNodes)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      type: "button",
                                      class: "pb-mi",
                                      role: "menuitem",
                                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.duplicateNode()))
                                    }, [...(_cache[68] || (_cache[68] = [
                                      _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                                        _createElementVNode("path", { d: "M9 9h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2V9zM5 15H4a1 1 0 0 1-1-1V5a2 2 0 0 1 2-2h9a1 1 0 0 1 1 1v1" })
                                      ], -1),
                                      _createTextVNode("Duplicate ", -1)
                                    ]))]))
                                  : _createCommentVNode("", true),
                                (_ctx.canImprove)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 2,
                                      type: "button",
                                      class: "pb-mi",
                                      role: "menuitem",
                                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.improveWithAI()))
                                    }, [...(_cache[69] || (_cache[69] = [
                                      _createElementVNode("svg", {
                                        viewBox: "0 0 24 24",
                                        class: "pb-mi-fill"
                                      }, [
                                        _createElementVNode("path", { d: "M13 0L3.5 14H10l-1.5 10L20 9h-6.5L15 0h-2z" })
                                      ], -1),
                                      _createTextVNode("Improve with AI ", -1)
                                    ]))]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                  (_ctx.canEditNodes && _ctx.node.Type == 'NODE' && _ctx.node.Slug != 'home')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "ai-btn playbook-ai-launcher",
                        title: 'Make something in ' + _ctx.node.Name + ' with The Forge',
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showAICreate = true))
                      }, [...(_cache[70] || (_cache[70] = [
                        _createElementVNode("svg", {
                          "aria-hidden": "true",
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "15",
                          height: "15",
                          viewBox: "0 0 24 24",
                          fill: "currentColor",
                          "fill-rule": "evenodd"
                        }, [
                          _createElementVNode("path", { d: "M12 23c-4.4 0-8-3.1-8-7.5 0-3.3 2-5.6 3.6-7.4.4-.4 1.1-.1 1.1.5 0 1.3.6 2.6 1.6 3.2C10.1 7.7 11.6 4 15 1.2c.4-.3 1 0 1 .5-.1 2.6.9 4.5 2.2 6.4C19.3 9.8 20 11.6 20 15.5 20 19.9 16.4 23 12 23zm0-2c1.9 0 3.3-1.3 3.3-3.1 0-1.6-.9-2.7-2.1-3.9-.3-.3-.8-.1-.8.3-.1 1-.6 1.8-1.3 2.2-.1-1.1-.5-2-1.1-2.6-.3-.3-.8-.1-.8.3-.3 1.3-1.5 2.2-1.5 3.7C7.7 19.7 9.8 21 12 21z" })
                        ], -1),
                        _createTextVNode("Forge here", -1)
                      ]))], 8, _hoisted_24))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_25, [
                    (_ctx.node.Slug != 'home')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "btn-light",
                          style: {"margin-right":"15px"},
                          onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.$router.back()))
                        }, "Back"))
                      : _createCommentVNode("", true)
                  ])
                ], 64))
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.blocked)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          (_ctx.blocked.status == 403)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_27, [...(_cache[71] || (_cache[71] = [
                _createElementVNode("rect", {
                  x: "4",
                  y: "11",
                  width: "16",
                  height: "10",
                  rx: "2"
                }, null, -1),
                _createElementVNode("path", { d: "M8 11V7a4 4 0 0 1 8 0v4" }, null, -1)
              ]))]))
            : (_openBlock(), _createElementBlock("svg", _hoisted_28, [...(_cache[72] || (_cache[72] = [
                _createElementVNode("circle", {
                  cx: "11",
                  cy: "11",
                  r: "7"
                }, null, -1),
                _createElementVNode("path", { d: "M21 21l-5-5" }, null, -1)
              ]))])),
          _createElementVNode("h2", null, _toDisplayString(_ctx.blocked.status == 403 ? 'You Don\'t Have Access' : 'Page Not Found'), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.blocked.message), 1),
          _createElementVNode("div", _hoisted_29, [
            (_ctx.canGoBack)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn-light",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.$router.back()))
                }, "Back"))
              : _createCommentVNode("", true),
            _createVNode(_component_router_link, {
              to: "/playbook/home",
              class: "btn"
            }, {
              default: _withCtx(() => [...(_cache[73] || (_cache[73] = [
                _createTextVNode("Go to Home", -1)
              ]))]),
              _: 1
            })
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
        }, [
          (_ctx.gettingPDF)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, "Preparing PDF…"))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.hasRail ? 'playbook-' + _ctx.node.Type + ' playbook-with-rail' : 'playbook-' + _ctx.node.Type),
            style: {"display":"flex","justify-content":"center"}
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.node.Type == 'NODE' ? '' : 'playbook'),
              style: _normalizeStyle(_ctx.node.Type == 'NODE' ? 'width:1160px;max-width:100%' : '')
            }, [
              (_ctx.node.Slug == 'home' && _ctx.$store.state.user.teamHubEmployeeLoaded && _ctx.$store.state.user.teamHubEmployee)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createVNode(_component_forge_daily_digest),
                    _createVNode(_component_employee_home_node)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.$store.state.adminRolesCanEdit.includes(_ctx.$store.state.user.role) && _ctx.node.Type == 'NODE' && _ctx.node.Slug != 'home')
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _createElementVNode("div", {
                      class: "add-btn",
                      title: "Add manually",
                      onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.addEditNode(null)))
                    }, "Add New"),
                    _createElementVNode("div", {
                      class: "add-btn",
                      onClick: _cache[21] || (_cache[21] = () => { _ctx.showAddExisting = true })
                    }, "Add Existing")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.nextNodes.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    (!_ctx.showReorder)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nextNodes, (next, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: i,
                              class: "next-node-card-wrap"
                            }, [
                              _createElementVNode("div", {
                                class: "next-node-card",
                                onClick: ($event: any) => (_ctx.handleNode(next))
                              }, [
                                _createElementVNode("div", _hoisted_36, [
                                  _createElementVNode("div", _hoisted_37, _toDisplayString(next.Name), 1),
                                  (_ctx.$store.state.user.isAdmin)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        class: "next-node-menu-btn",
                                        onClick: _withModifiers(($event: any) => (_ctx.toggleNextNodeMenu(next, $event)), ["stop"])
                                      }, [
                                        _createVNode(_component_svg_icon, { icon: "dots" })
                                      ], 8, _hoisted_38))
                                    : _createCommentVNode("", true)
                                ]),
                                (next.nextNodes.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(next.nextNodes.length) + " subnode" + _toDisplayString(next.nextNodes.length == 1 ? '' : 's'), 1))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_35),
                              (_ctx.openNextNodeSlug == next.Slug)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "next-node-menu-dropdown",
                                    style: _normalizeStyle(_ctx.nextNodeMenuStyle),
                                    onClick: _cache[22] || (_cache[22] = _withModifiers(() => {}, ["stop"]))
                                  }, [
                                    (_ctx.canEditNodes)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createElementVNode("a", {
                                            onClick: _withModifiers(($event: any) => (_ctx.nextNodeMenuAction(() => _ctx.addEditNode(next))), ["prevent"])
                                          }, "Edit Node", 8, _hoisted_40),
                                          (next.Type == 'PROCESS')
                                            ? (_openBlock(), _createBlock(_component_router_link, {
                                                key: 0,
                                                to: '/edit-process/' + next.Slug,
                                                onClick: _ctx.closeNextNodeMenu
                                              }, {
                                                default: _withCtx(() => [...(_cache[74] || (_cache[74] = [
                                                  _createTextVNode("Edit Process", -1)
                                                ]))]),
                                                _: 1
                                              }, 8, ["to", "onClick"]))
                                            : _createCommentVNode("", true),
                                          (next.Type == 'TIMELINE')
                                            ? (_openBlock(), _createBlock(_component_router_link, {
                                                key: 1,
                                                to: '/edit-timeline/' + next.Slug,
                                                onClick: _ctx.closeNextNodeMenu
                                              }, {
                                                default: _withCtx(() => [...(_cache[75] || (_cache[75] = [
                                                  _createTextVNode("Edit Value Engine", -1)
                                                ]))]),
                                                _: 1
                                              }, 8, ["to", "onClick"]))
                                            : _createCommentVNode("", true),
                                          (next.Type == 'SHEET')
                                            ? (_openBlock(), _createBlock(_component_router_link, {
                                                key: 2,
                                                to: '/edit-sheet/' + next.Slug,
                                                onClick: _ctx.closeNextNodeMenu
                                              }, {
                                                default: _withCtx(() => [...(_cache[76] || (_cache[76] = [
                                                  _createTextVNode("Edit Sheet", -1)
                                                ]))]),
                                                _: 1
                                              }, 8, ["to", "onClick"]))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("a", {
                                            onClick: _withModifiers(($event: any) => (_ctx.nextNodeMenuAction(() => _ctx.removeNode(next))), ["prevent"])
                                          }, "Remove from " + _toDisplayString(_ctx.node.Name), 9, _hoisted_41),
                                          _cache[77] || (_cache[77] = _createElementVNode("div", { class: "row-menu-divider" }, null, -1))
                                        ], 64))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_42, [
                                      _createElementVNode("span", null, _toDisplayString(_ctx.$store.state.playbookNodeTypeMap[next.Type]), 1),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(next.Locations, (location, k) => {
                                        return (_openBlock(), _createElementBlock("span", { key: k }, _toDisplayString(location), 1))
                                      }), 128)),
                                      (next.NeedsApproval)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_43, "NEEDS APPROVAL"))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (next.nextNodes.length)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                          _cache[78] || (_cache[78] = _createElementVNode("div", { class: "row-menu-divider" }, null, -1)),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(next.nextNodes, (nextNext, j) => {
                                            return (_openBlock(), _createElementBlock("a", {
                                              key: j,
                                              onClick: _withModifiers(($event: any) => (_ctx.handleNode(nextNext)), ["prevent"])
                                            }, _toDisplayString(nextNext.Name), 9, _hoisted_45))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true)
                                  ], 4))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.$store.state.adminRolesCanEdit.includes(_ctx.$store.state.user.role))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          (_ctx.showReorder)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                _createVNode(_component_draggable, {
                                  modelValue: _ctx.nextNodes,
                                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.nextNodes) = $event)),
                                  class: "next-nodes"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nextNodes, (next, i) => {
                                      return (_openBlock(), _createElementBlock("div", { key: i }, [
                                        _createElementVNode("div", _hoisted_48, _toDisplayString(next.Name), 1)
                                      ]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_49, [
                            _createElementVNode("span", {
                              onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.toggleShowReorder())),
                              style: {"cursor":"pointer","text-decoration":"underline"}
                            }, [
                              (_ctx.showReorder)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_50, "Save"))
                                : (_openBlock(), _createElementBlock("span", _hoisted_51, "Reorder"))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.node.Slug == 'home' && _ctx.$store.state.user.teamHubEmployeeLoaded)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                          _createVNode(_component_announcements_home_node)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (_ctx.process)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                      _createVNode(_component_process_header, {
                        node: _ctx.node,
                        "location-string": _ctx.locationString,
                        "departments-string": _ctx.departmentsString,
                        "node-types-string": _ctx.nodeTypesString,
                        "last-modified": _ctx.lastModified,
                        "last-reviewed": _ctx.lastReviewed,
                        "prev-nodes": _ctx.prevNodes,
                        files: _ctx.files,
                        "link-target": _ctx.previewNode ? '_blank' : null
                      }, null, 8, ["node", "location-string", "departments-string", "node-types-string", "last-modified", "last-reviewed", "prev-nodes", "files", "link-target"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processStepGroups, (group, g) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: g,
                          class: _normalizeClass(['playbook-steps', group.layout ? 'playbook-steps-' + group.layout : ''])
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.steps, ({ item, i }) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: i,
                              class: _normalizeClass(['playbook-process', { 'playbook-process-hide-line': item.hideSectionLine, 'playbook-process-changed': _ctx.changedSteps && _ctx.changedSteps.includes(i) }])
                            }, [
                              _createElementVNode("h3", null, _toDisplayString(item.header), 1),
                              (item.body)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    innerHTML: item.body,
                                    style: {"text-align":"left"}
                                  }, null, 8, _hoisted_54))
                                : _createCommentVNode("", true),
                              (item.image || item.image2)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: _normalizeClass((item.image && item.image2) ? 'playbook-process-images playbook-process-multi-images' : 'playbook-process-images')
                                  }, [
                                    (item.image)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                          _createElementVNode("img", {
                                            src: item.image
                                          }, null, 8, _hoisted_56)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (item.image2)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                          _createElementVNode("img", {
                                            src: item.image2
                                          }, null, 8, _hoisted_58)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ], 2))
                                : _createCommentVNode("", true),
                              (item.video)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                    _createElementVNode("div", _hoisted_60, [
                                      (item.video.includes('.mp4') || item.video.includes('.webm') || item.video.includes('.ogg'))
                                        ? (_openBlock(), _createElementBlock("video", _hoisted_61, [
                                            _createElementVNode("source", {
                                              src: item.video
                                            }, null, 8, _hoisted_62)
                                          ]))
                                        : (_openBlock(), _createElementBlock("iframe", {
                                            key: 1,
                                            src: item.video,
                                            allowfullscreen: "true",
                                            autostart: "0"
                                          }, null, 8, _hoisted_63))
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2))
                          }), 128))
                        ], 2))
                      }), 128))
                    ]))
                  : (_ctx.timeline)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                        _createVNode(_component_process_header, {
                          node: _ctx.node,
                          "location-string": _ctx.locationString,
                          "departments-string": _ctx.departmentsString,
                          "node-types-string": _ctx.nodeTypesString,
                          "last-modified": _ctx.lastModified,
                          "last-reviewed": _ctx.lastReviewed,
                          "prev-nodes": _ctx.prevNodes,
                          files: _ctx.files,
                          "link-target": _ctx.previewNode ? '_blank' : null
                        }, null, 8, ["node", "location-string", "departments-string", "node-types-string", "last-modified", "last-reviewed", "prev-nodes", "files", "link-target"]),
                        _createVNode(_component_value_engine_view, {
                          items: _ctx.timeline.items || [],
                          "changed-steps": _ctx.changedSteps,
                          onOpenLink: _cache[25] || (_cache[25] = ($event: any) => (_ctx.timelineLink($event))),
                          onOpenImage: _cache[26] || (_cache[26] = ($event: any) => (_ctx.openImagePop($event)))
                        }, null, 8, ["items", "changed-steps"])
                      ]))
                    : (_ctx.sheet)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                          _createVNode(_component_process_header, {
                            node: _ctx.node,
                            "location-string": _ctx.locationString,
                            "departments-string": _ctx.departmentsString,
                            "node-types-string": _ctx.nodeTypesString,
                            "last-modified": _ctx.lastModified,
                            "last-reviewed": _ctx.lastReviewed,
                            "prev-nodes": _ctx.prevNodes,
                            files: _ctx.files,
                            "link-target": _ctx.previewNode ? '_blank' : null
                          }, null, 8, ["node", "location-string", "departments-string", "node-types-string", "last-modified", "last-reviewed", "prev-nodes", "files", "link-target"]),
                          _createVNode(_component_role_sheet_view, {
                            sheet: _ctx.sheet,
                            "initial-seat-id": _ctx.initialSeatId,
                            actions: !_ctx.previewNode,
                            "is-admin": _ctx.$store.state.user.isAdmin,
                            onSign: _cache[27] || (_cache[27] = ($event: any) => (_ctx.signSeat($event))),
                            onShare: _cache[28] || (_cache[28] = ($event: any) => (_ctx.sharePDF($event.id))),
                            onOpenLink: _cache[29] || (_cache[29] = ($event: any) => (_ctx.timelineLink($event)))
                          }, null, 8, ["sheet", "initial-seat-id", "actions", "is-admin"])
                        ]))
                      : (_ctx.node.Type == 'VIDEO')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                            _createVNode(_component_process_header, {
                              node: _ctx.node,
                              "location-string": _ctx.locationString,
                              "departments-string": _ctx.departmentsString,
                              "node-types-string": _ctx.nodeTypesString,
                              "last-modified": _ctx.lastModified,
                              "last-reviewed": _ctx.lastReviewed,
                              "prev-nodes": _ctx.prevNodes,
                              files: _ctx.files,
                              "link-target": _ctx.previewNode ? '_blank' : null
                            }, null, 8, ["node", "location-string", "departments-string", "node-types-string", "last-modified", "last-reviewed", "prev-nodes", "files", "link-target"]),
                            _createElementVNode("div", _hoisted_67, [
                              _createElementVNode("div", _hoisted_68, [
                                (_ctx.node.Link.includes('.mp4') || _ctx.node.Link.includes('.webm') || _ctx.node.Link.includes('.ogg'))
                                  ? (_openBlock(), _createElementBlock("video", _hoisted_69, [
                                      _createElementVNode("source", {
                                        src: _ctx.node.Link
                                      }, null, 8, _hoisted_70)
                                    ]))
                                  : (_openBlock(), _createElementBlock("iframe", {
                                      key: 1,
                                      src: _ctx.node.Link,
                                      allowfullscreen: "true",
                                      autostart: "0"
                                    }, null, 8, _hoisted_71))
                              ])
                            ])
                          ]))
                        : (_ctx.checklist)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                              _createElementVNode("div", _hoisted_73, [
                                _createVNode(_component_checklist, {
                                  checklistProp: _ctx.checklist,
                                  slug: _ctx.node.Slug
                                }, null, 8, ["checklistProp", "slug"])
                              ])
                            ]))
                          : _createCommentVNode("", true),
              (_ctx.node.Slug == 'home')
                ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                    _createVNode(_component_nodes_home_node)
                  ]))
                : _createCommentVNode("", true)
            ], 6),
            (_ctx.hasRail)
              ? (_openBlock(), _createBlock(_component_node_admin_component, {
                  key: 0,
                  slug: _ctx.node.Slug,
                  nodeName: _ctx.node.Name,
                  node: _ctx.node,
                  onFilesChanged: _cache[31] || (_cache[31] = ($event: any) => (_ctx.getFiles()))
                }, {
                  default: _withCtx(() => [
                    (!_ctx.$store.state.user.isAdmin)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "rz-after-btn",
                          onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.showSuggestion = true))
                        }, [...(_cache[79] || (_cache[79] = [
                          _createElementVNode("svg", {
                            viewBox: "0 0 24 24",
                            "aria-hidden": "true"
                          }, [
                            _createElementVNode("path", { d: "M9 18h6M10 21h4M12 3a6 6 0 0 0-3.5 10.9c.6.4 1 1.1 1 1.8V16h5v-.3c0-.7.4-1.4 1-1.8A6 6 0 0 0 12 3z" })
                          ], -1),
                          _createTextVNode("Suggest an Improvement", -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["slug", "nodeName", "node"]))
              : _createCommentVNode("", true)
          ], 2)
        ], 2)),
    (_ctx.showColSignOff)
      ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
          _createElementVNode("div", _hoisted_76, [
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("button", {
                type: "button",
                class: "form-close-x",
                title: "Close",
                onClick: _cache[32] || (_cache[32] = () => { _ctx.showColSignOff = false })
              }, "×")
            ]),
            _createElementVNode("div", _hoisted_78, [
              _createVNode(_component_VueSignaturePad, { ref: 'signOffPad' })
            ]),
            _createElementVNode("div", _hoisted_79, [
              _cache[80] || (_cache[80] = _createElementVNode("b", null, "Sign Name Above", -1)),
              _cache[81] || (_cache[81] = _createTextVNode(" - ", -1)),
              _createElementVNode("a", {
                onClick: _cache[33] || (_cache[33] = _withModifiers(() => { (_ctx.$refs as any).signOffPad.clearSignature() }, ["prevent"]))
              }, "Clear")
            ]),
            _withDirectives(_createElementVNode("input", {
              style: {"margin-top":"15px"},
              type: "text",
              placeholder: "Type your name",
              "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.colSignOffInput) = $event))
            }, null, 512), [
              [_vModelText, _ctx.colSignOffInput]
            ]),
            _createElementVNode("input", {
              class: _normalizeClass(_ctx.colSignOffSubmitting ? 'disable-button' : ''),
              type: "submit",
              value: "Submit",
              onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.submitColSignOff()))
            }, null, 2)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.presenting && _ctx.timeline)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: "ve-present",
          role: "dialog",
          "aria-label": _ctx.node.Name
        }, [
          _createElementVNode("div", _hoisted_81, [
            _createElementVNode("span", _hoisted_82, _toDisplayString(_ctx.node.Name), 1),
            _createElementVNode("button", {
              type: "button",
              class: "ve-present-close",
              title: "Close (Esc)",
              "aria-label": "Close",
              onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.presenting = false))
            }, [...(_cache[82] || (_cache[82] = [
              _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
                _createElementVNode("path", { d: "M6 6l12 12M18 6L6 18" })
              ], -1)
            ]))])
          ]),
          _createElementVNode("div", _hoisted_83, [
            _createVNode(_component_value_engine_view, {
              items: _ctx.timeline.items || [],
              onOpenLink: _cache[37] || (_cache[37] = ($event: any) => (_ctx.timelineLink($event))),
              onOpenImage: _cache[38] || (_cache[38] = ($event: any) => (_ctx.openImagePop($event)))
            }, null, 8, ["items"])
          ])
        ], 8, _hoisted_80))
      : _createCommentVNode("", true),
    (_ctx.showImagePop)
      ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
          _createElementVNode("div", _hoisted_85, [
            _createElementVNode("div", _hoisted_86, [
              _createElementVNode("button", {
                type: "button",
                class: "form-close-x",
                title: "Close",
                onClick: _cache[39] || (_cache[39] = () => { _ctx.showImagePop = false })
              }, "×")
            ]),
            _createElementVNode("div", _hoisted_87, [
              _createElementVNode("img", {
                style: {"max-width":"1000px","width":"100%"},
                src: _ctx.imagePopURL
              }, null, 8, _hoisted_88)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showSharePDF)
      ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
          _createElementVNode("div", _hoisted_90, [
            _createElementVNode("div", _hoisted_91, [
              _createElementVNode("button", {
                type: "button",
                class: "form-close-x",
                title: "Close",
                onClick: _cache[40] || (_cache[40] = () => { _ctx.showSharePDF = false })
              }, "×")
            ]),
            _createElementVNode("div", _hoisted_92, [
              _createElementVNode("a", {
                onClick: _cache[41] || (_cache[41] = _withModifiers(($event: any) => (_ctx.copyLink()), ["prevent"]))
              }, "Copy Link")
            ]),
            _cache[84] || (_cache[84] = _createElementVNode("h3", null, "Email", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.shareData.email) = $event)),
              placeholder: "Email"
            }, null, 512), [
              [_vModelText, _ctx.shareData.email]
            ]),
            _cache[85] || (_cache[85] = _createElementVNode("h3", null, "Phone", -1)),
            _createVNode(_component_phone_input, {
              modelValue: _ctx.shareData.phone,
              "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.shareData.phone) = $event)),
              placeholder: "Phone"
            }, null, 8, ["modelValue"]),
            (_ctx.checklist)
              ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.shareData.wDescriptions) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.shareData.wDescriptions]
                  ]),
                  _cache[83] || (_cache[83] = _createElementVNode("h3", null, "w/ Lines", -1))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("input", {
              class: _normalizeClass(_ctx.gettingPDF ? 'disable-button' : ''),
              type: "submit",
              value: "Send",
              onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.getPDF(false, true)))
            }, null, 2)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showWhoCanView)
      ? (_openBlock(), _createBlock(_component_who_can_view, {
          key: 7,
          slug: _ctx.node.Slug,
          onClose: _cache[46] || (_cache[46] = () => { _ctx.showWhoCanView = false })
        }, null, 8, ["slug"]))
      : _createCommentVNode("", true),
    (_ctx.showPDF)
      ? (_openBlock(), _createBlock(_component_pdf_pop_up, {
          key: 8,
          url: _ctx.PDFUrl,
          onClose: _cache[47] || (_cache[47] = () => _ctx.showPDF = false)
        }, null, 8, ["url"]))
      : _createCommentVNode("", true),
    (_ctx.showAICreate)
      ? (_openBlock(), _createBlock(_component_ai_create_node, {
          key: 9,
          "node-type": "process",
          "from-slug": _ctx.node.Slug == 'home' ? null : _ctx.node.Slug,
          onClose: _cache[48] || (_cache[48] = ($event: any) => (_ctx.closeAICreate()))
        }, null, 8, ["from-slug"]))
      : _createCommentVNode("", true),
    (_ctx.showAddEdit)
      ? (_openBlock(), _createBlock(_component_add_edit_node, {
          key: 10,
          node: _ctx.nodeToEdit,
          fromSlug: _ctx.duplicatingNode ? null : _ctx.node.Slug,
          cloneNode: _ctx.duplicatingNode,
          onClose: _cache[49] || (_cache[49] = ($event: any) => (_ctx.closeAddEdit()))
        }, null, 8, ["node", "fromSlug", "cloneNode"]))
      : _createCommentVNode("", true),
    (_ctx.showAddExisting)
      ? (_openBlock(), _createBlock(_component_add_existing_node, {
          key: 11,
          fromSlug: _ctx.node.Slug,
          onClose: _cache[50] || (_cache[50] = ($event: any) => (_ctx.closeAddExisting()))
        }, null, 8, ["fromSlug"]))
      : _createCommentVNode("", true),
    (_ctx.showConfirmDelete)
      ? (_openBlock(), _createBlock(_component_confirm_delete, {
          key: 12,
          onConfirm: _ctx.deleteNodeConfirm,
          onCancel: _cache[51] || (_cache[51] = () => { _ctx.showConfirmDelete = false; }),
          msg: "Are you sure you would like to delete this item?"
        }, null, 8, ["onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.showConfirmRemove)
      ? (_openBlock(), _createBlock(_component_confirm_delete, {
          key: 13,
          onConfirm: _ctx.removeNodeConfirm,
          onCancel: _cache[52] || (_cache[52] = () => { _ctx.showConfirmRemove = false; }),
          msg: 'Are you sure you would like to remove this item from ' + _ctx.node.Name + '?'
        }, null, 8, ["onConfirm", "msg"]))
      : _createCommentVNode("", true),
    (_ctx.showSuggestion)
      ? (_openBlock(), _createBlock(_component_process_suggestion_form, {
          key: 14,
          nodeName: _ctx.node.Name,
          slug: _ctx.node.Slug,
          onClose: _cache[53] || (_cache[53] = ($event: any) => (_ctx.showSuggestion = false))
        }, null, 8, ["nodeName", "slug"]))
      : _createCommentVNode("", true)
  ]))
}